import Backend from 'App/Dataman-Backend';

const {
  apiUrlPatents,
  apiUrlSuffix,
  apiUrlPatentContents,
  apiUrlPatentDescriptions,
  apiUrlPatentClaims,
  apiUrlPatentsExplore,
  apiPatentInternalNotes,
  apiPatentCitations,
  apiPatents,
  apiCpcClassifications,
  apiIpcClassifications,
  apiUrlPatentCpcClassification,
  apiUrlPatentIpcClassification,
} = Backend.config;

export const PATENTS_PATHS = {
  patents: apiUrlPatents,
  suffix: apiUrlSuffix,
  contents: apiUrlPatentContents,
  descriptions: apiUrlPatentDescriptions,
  claims: apiUrlPatentClaims,
  explore: apiUrlPatentsExplore,
  internalNotes: apiPatentInternalNotes,
  citations: apiPatentCitations,
  legalEventsBase: apiPatents,
  cpcClassifications: apiCpcClassifications,
  ipcClassifications: apiIpcClassifications,
  cpcClassification: apiUrlPatentCpcClassification,
  ipcClassification: apiUrlPatentIpcClassification,
};
